import React from 'react';
import { Link } from 'react-router-dom';

const FoodSafetyCompliance = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto">
        <div className="bg-white shadow rounded-lg p-8">
          <div className="mb-8">
            <h1 className="text-3xl font-bold text-gray-900 mb-4">Food Safety & Compliance</h1>
            <Link
              to="/legal"
              className="text-blue-600 hover:text-blue-500 font-medium"
            >
              ← Back to Legal Center
            </Link>
          </div>

          <div className="prose max-w-none">
            <h2 className="text-xl font-semibold text-gray-900 mb-4">1. Cottage Food vs Commercial Kitchen</h2>
            <p className="text-gray-700 mb-6">
              Food creators must clearly indicate whether they operate under cottage food laws or commercial 
              kitchen regulations. Cottage food operations are limited to specific food items and sales volumes. 
              Commercial kitchens must meet all local health department requirements.
            </p>

            <h2 className="text-xl font-semibold text-gray-900 mb-4">2. Ingredient Labeling Requirements</h2>
            <p className="text-gray-700 mb-6">
              All food items must include complete ingredient lists. Common allergens (dairy, eggs, fish, 
              shellfish, tree nuts, peanuts, wheat, soy) must be clearly identified. Nutritional information 
              should be provided when possible.
            </p>

            <h2 className="text-xl font-semibold text-gray-900 mb-4">3. Allergen Management</h2>
            <p className="text-gray-700 mb-6">
              Sellers must disclose potential cross-contamination risks. Separate preparation areas and 
              equipment should be used for allergen-free items. Customers with severe allergies should be 
              informed of all potential risks.
            </p>

            <h2 className="text-xl font-semibold text-gray-900 mb-4">4. Food Safety Audits</h2>
            <p className="text-gray-700 mb-6">
              Vesta may conduct periodic food safety audits of seller operations. These audits ensure 
              compliance with platform standards and local regulations. Sellers must cooperate with audit 
              requests and address any identified issues promptly.
            </p>

            <h2 className="text-xl font-semibold text-gray-900 mb-4">5. Temperature Control</h2>
            <p className="text-gray-700 mb-6">
              Proper temperature control is essential for food safety. Hot foods must be maintained above 
              140°F, cold foods below 41°F, and frozen foods below 0°F. Temperature logs should be kept 
              for all food preparation and storage.
            </p>

            <h2 className="text-xl font-semibold text-gray-900 mb-4">6. Sanitation Standards</h2>
            <p className="text-gray-700 mb-6">
              All food preparation areas must be kept clean and sanitary. Regular cleaning schedules must 
              be maintained, and all equipment must be properly sanitized between uses. Personal hygiene 
              standards must be followed at all times.
            </p>

            <div className="mt-8 pt-6 border-t border-gray-200">
              <p className="text-sm text-gray-500">
                Last updated: {new Date().toLocaleDateString()}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FoodSafetyCompliance; 